var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoldIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0989 0.869652L8.91084 7.3337L1.77793 8.37361C0.498795 8.55913 -0.0138367 10.1361 0.913783 11.0393L6.07428 16.068L4.85373 23.1716C4.63403 24.4556 5.9864 25.4174 7.11907 24.8169L13.5001 21.4628L19.8812 24.8169C21.0138 25.4125 22.3662 24.4556 22.1465 23.1716L20.926 16.068L26.0865 11.0393C27.0141 10.1361 26.5014 8.55913 25.2223 8.37361L18.0894 7.3337L14.9013 0.869652C14.3301 -0.282549 12.675 -0.297196 12.0989 0.869652Z",
    fill: "#020C41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldIcon);
export default __webpack_public_path__ + "static/media/gold_icon.a9d95c6ea0923690a1db971cddfd8d51.svg";
export { ForwardRef as ReactComponent };